export const AT = {
    localStorageKey: "",
    sessionStorageKey: "",
    isLocalStorage: false,

    init: () => {
        const modals = document.querySelectorAll('.js-announce-modal');
        modals.forEach(m => {
            const closeBtn = m.querySelector('.js-btn-close');
            const toggleBtn = m.querySelector('.js-btn-toggle');
            const wrapper = m.querySelector('.js-wrapper');
            const id = closeBtn?.dataset.id;
            const broadcastMode = m.dataset.broadcastMode;
            AT.isLocalStorage = broadcastMode === 'oneTimePerVisitor';

            // already closed with session
            const isClosed = AT.isLocalStorage
                ? AT.loadLocalStorage(id, "announce_closed")
                : AT.loadSessionStorage(id, "announce_closed");

            // not closed, show
            if (!isClosed) {
                m.classList.add('show');
                m.classList.add('d-block');
                m.classList.remove('d-none');
            } else {
                m.classList.remove('show');
                m.classList.remove('d-block');
                m.classList.add('d-none');
            }

            // attach events
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    AT.closeAnnouncement(id);
                    m.classList.remove('show');
                    m.classList.remove('d-block');
                    m.classList.add('d-none');
                });
            }

            if (toggleBtn && wrapper) {
                toggleBtn.addEventListener('click', () => {
                    wrapper.classList.toggle('d-none');
                    const arrow = toggleBtn.querySelector('.arrow');
                    if (arrow) arrow.classList.toggle('ti-angle-down');
                    if (arrow) arrow.classList.toggle('ti-angle-right');
                });
            }
        });
    },

    closeAnnouncement: (announcementId) => {
        if (AT.isLocalStorage) 
            AT.saveLocalStorageKey(announcementId);
        else
            AT.saveSessionStorageKey(announcementId);
    },

    loadLocalStorage: (announcementID, storageKey) => {
        AT.localStorageKey = storageKey;
        AT.isLocalStorage = true;

        let ids = [];
        let isClosed = false;

        if (!localStorage.getItem(storageKey))
            localStorage.setItem(storageKey, JSON.stringify([]));

        ids = JSON.parse(localStorage.getItem(storageKey));

        if (ids.includes(announcementID))
            isClosed = true;

        return isClosed;
    },

    saveLocalStorageKey: (announcementID) => {
        let ids = [];

        if (localStorage.getItem(AT.localStorageKey))
            ids = JSON.parse(localStorage.getItem(AT.localStorageKey));

        if (!ids.includes(announcementID)) {
            ids.push(announcementID);
            localStorage.setItem(AT.localStorageKey, JSON.stringify(ids));
        }
    },

    //Session
    loadSessionStorage: (announcementID, storageKey) => {
        AT.sessionStorageKey = storageKey;
        AT.isLocalStorage = false;

        let ids = [];
        let isClosed = false;

        if (!sessionStorage.getItem(storageKey))
            sessionStorage.setItem(storageKey, JSON.stringify([]));

        ids = JSON.parse(sessionStorage.getItem(storageKey));

        if (ids.includes(announcementID))
            isClosed = true;

        return isClosed;
    },

    saveSessionStorageKey: (announcementID) => {
        let ids = [];

        if (sessionStorage.getItem(AT.sessionStorageKey))
            ids = JSON.parse(sessionStorage.getItem(AT.sessionStorageKey));

        if (!ids.includes(announcementID)) {
            ids.push(announcementID);
            sessionStorage.setItem(AT.sessionStorageKey, JSON.stringify(ids));
        }
    }
}
